export var required = function required() {
  return {
    name: 'required',
    staticProps: {
      'aria-required': 'true'
    },
    validate: function validate(fieldName) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (value) {
        return null;
      }
      return "".concat(fieldName, " is required.");
    }
  };
};

// Taken from here: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email#basic_validation
var emailPattern =
// eslint-disable-next-line max-len
/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export var email = function email() {
  return {
    name: 'email',
    staticProps: {
      /* autocomplete: 'email' ???? */
      /* Other than aria props it may not make sense to set anything else here
        in cases where this is used in non `input` elements
      */
    },
    validate: function validate(fieldName) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (value && !emailPattern.test(value)) {
        return 'Must be a valid email.';
      }
      return null;
    }
  };
};
export var minLength = function minLength(min) {
  return {
    name: 'minLength',
    staticProps: {},
    validate: function validate(fieldName) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (value && value.length < min) {
        return "".concat(fieldName, " must be at least ").concat(min, " characters.");
      }
      return null;
    }
  };
};
export var maxLength = function maxLength(max) {
  return {
    name: 'maxLength',
    staticProps: {},
    validate: function validate(fieldName) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (value && value.length > max) {
        return "".concat(fieldName, " must be less than or equal to ").concat(max, " characters.");
      }
      return null;
    }
  };
};
export var pattern = function pattern(regExp) {
  var patternMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : regExp;
  var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return {
    name: 'pattern',
    staticProps: {},
    validate: function validate(fieldName) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (value && !regExp.test(value)) {
        if (message) {
          return message;
        }
        return "".concat(fieldName, " must match pattern ").concat(patternMsg, ".");
      }
      return null;
    }
  };
};